import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  padding: 16px 24px 24px;
  height: 100%;
`;

export const Title = styled.h1`
  flex: 1;
  font-style: normal;
  white-space: nowrap;
  font-weight: normal;
  font-size: 18px;
  align-items: center;
  display: flex;
  margin: 0;
  flex-direction: row;
  color: ${beam.font.primary};
`;

export const Description = styled(Title)`
  font-size: 14px;
  white-space: normal;
  font-weight: 300;
  width: auto;
  color: ${beam.font.primary};
`;

export const RedTitle = styled.h1`
  flex: 1;
  font-style: normal;
  font-weight: normal;
  cursor: pointer;
  font-size: 14px;
  color: #ea1212;
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 0 24px 0 0;
`;
export const Icon = styled.img`
  display: flex;
  margin-right: 8px;
  width: 14px;
  height: 14px;
`;
export const DarkTitle = styled(Title)`
  margin-right: 8px;
  font-weight: 500;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Close = styled.button`
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  border: none;
  background: transparent;
`;

export const Lines = styled.div`
  border-top: 1px solid ${beam.lines.white};
  border-bottom: 1px solid ${beam.lines.white};
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 40px;

  & + & {
    border-top: 1px solid ${beam.lines.white};
  }
`;

export const Name = styled.div`
  flex: 1;
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  margin: 0 8px;
`;

export const Bottom = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
`;

export const BottomText = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  border: none;
  background: transparent;
  :disabled {
    color: ${beam.placeholder.primary};
    cursor: auto;
  }
`;

export const BottomButton = styled.button`
  border: none;
  box-shadow: 1px 1px 5px 0 #323b5433;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${beam.color.primaryBlue};
  background: ${beam.color.pureWhite};
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 16px;
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;
export const Search = styled.input`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.placeholder.primary};
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: ${beam.placeholder.primary};
  }
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow: auto;
  margin-top: 24px;
  height: 335px;
  & > div {
    margin-left: 0 !important;
    margin-bottom: 16px !important;
  }
`;

export const Tag = styled.div`
  display: flex;
  flex-direction: row;
  height: 30;
  border-radius: 15px;
  padding: 4px 12px;
  background-color: #edeff4;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  gap: 4px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #474d66;
`;

export const LineDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
  margin-bottom: 16px;
`;

export const WrapperRowButton = styled.button`
  display: flex;
  flex-direction: row;
  border: 0;
  background-color: transparent;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  &.title {
    font-size: 14px;
    font-weight: 500;
  }
`;

interface IDivider {
  height?: string;
  width?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TagsText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
`;
